export const SETNOTIFICATIONLIST = "SETNOTIFICATIONLIST";
